/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Custom function to update availability filter text
  function updateAvailabilityFilterText() {
    // Update filter labels based on current locale
    const availabilityFilters = document.querySelectorAll('[name="filter.v.availability"]');
    
    availabilityFilters.forEach(filter => {
      const label = filter.nextElementSibling; // Get the label element
      if (label && label.tagName === 'LABEL') {
        const labelText = label.childNodes[0]; // Get the text node
        
        // Check the filter value and update text accordingly
        if (filter.value === '1') {
          // Available products - change "Stokta" to "Satışta"
          if (labelText && labelText.textContent && labelText.textContent.includes('Stokta')) {
            labelText.textContent = labelText.textContent.replace('Stokta', 'Satışta');
          }
          // For global site - change "In Stock" to "Available"
          if (labelText && labelText.textContent && labelText.textContent.includes('In Stock')) {
            labelText.textContent = labelText.textContent.replace('In Stock', 'Available');
          }
          // Also check for "In stock" (lowercase s)
          if (labelText && labelText.textContent && labelText.textContent.includes('In stock')) {
            labelText.textContent = labelText.textContent.replace('In stock', 'Available');
          }
        } else if (filter.value === '0') {
          // Unavailable products - change "Stokta yok" to "Tükendi"
          if (labelText && labelText.textContent && labelText.textContent.includes('Stokta yok')) {
            labelText.textContent = labelText.textContent.replace('Stokta yok', 'Tükendi');
          }
          // For global site - change "Out of Stock" to "Sold Out"
          if (labelText && labelText.textContent && labelText.textContent.includes('Out of Stock')) {
            labelText.textContent = labelText.textContent.replace('Out of Stock', 'Sold Out');
          }
          // Also check for "Out of stock" (lowercase s)
          if (labelText && labelText.textContent && labelText.textContent.includes('Out of stock')) {
            labelText.textContent = labelText.textContent.replace('Out of stock', 'Sold Out');
          }
        }
      }
    });
  }

  function formatThemeMoney(cents) {
  if (window.themeCurrency && window.theme && window.theme.moneyFormat) {
    if (window.theme.settings && window.theme.settings.currency_code_enable) {
      return window.themeCurrency.formatMoney(cents, window.theme.moneyFormat) + ` ${window.theme.currencyCode}`;
    }
    return window.themeCurrency.formatMoney(cents, window.theme.moneyFormat);
  }

  if (window.Shopify && Shopify.formatMoney) {
    return Shopify.formatMoney(cents);
  }

  return cents;
}

function updateDynamicComparePrice(container, variant, partial) {
  const compareEls = container.querySelectorAll('[data-compare-price-dynamic]');
  const saleWraps = container.querySelectorAll('[data-price-off]');

  console.log('[COMPARE] updateDynamicComparePrice fired', { variant, compareElsCount: compareEls.length });

  if (!compareEls.length) {
    console.log('[COMPARE] data-compare-price-dynamic bulunamadı');
    return;
  }

  // bendis (30.10.2026): seçim tamamlanmamışken (variant yok) tema, eşleşen varyantların ortak indirimini
  // event.detail.bendisPartial ile verir; eski fiyat ve rozet o bilgiyle gösterilir.
  const partialSale = !variant && partial && partial.onSale && partial.compareMin != null;
  const hasCompare = (variant && variant.compare_at_price && variant.price && variant.compare_at_price > variant.price) || partialSale;
  const compareText = partialSale
    ? (partial.compareMin === partial.compareMax
        ? formatComparePriceTRY(partial.compareMin)
        : formatComparePriceTRY(partial.compareMin) + ' – ' + formatComparePriceTRY(partial.compareMax))
    : (hasCompare ? formatComparePriceTRY(variant.compare_at_price) : '');

  compareEls.forEach((el) => {
    if (hasCompare) {
      el.innerHTML = compareText;
      el.classList.remove('hide');
      console.log('[COMPARE] compare updated:', el.innerHTML);
    } else {
      el.innerHTML = '';
      el.classList.add('hide');
    }
  });

  saleWraps.forEach((wrap) => {
    wrap.classList.toggle('hide', !hasCompare);
  });
}

function formatComparePriceTRY(cents) {
  if (cents == null) return '';

  let formatted = '';

  if (window.themeCurrency && window.theme && window.theme.moneyFormat) {
    formatted = window.themeCurrency.formatMoney(cents, window.theme.moneyFormat);
  } else if (window.Shopify && Shopify.formatMoney) {
    formatted = Shopify.formatMoney(cents, window.theme?.moneyFormat || '{{ amount }}');
  } else {
    formatted = new Intl.NumberFormat('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  formatted = String(formatted).trim();

  formatted = formatted
    .replace(/\s*₺/g, '')
    .replace(/\s*TL\b/g, '')
    .replace(/\s*TRY\b/g, '')
    .trim();

  return `${new Intl.NumberFormat('tr-TR', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}).format(cents / 100)} TL`;
}

  // Custom function to update active filters text
  function updateActiveFiltersText() {
    // Update active filter labels in collection__active__filters__wrapper
    const activeFiltersWrapper = document.querySelector('.collection__active__filters__wrapper');
    
    if (activeFiltersWrapper) {
      const activeFilterLinks = activeFiltersWrapper.querySelectorAll('.active__filters__remove');
      
      activeFilterLinks.forEach(link => {
        // Check for "Stokta yok" text and replace with "Tükendi"
        if (link.textContent.includes('Stokta yok')) {
          link.innerHTML = link.innerHTML.replace('Stokta yok', 'Tükendi');
        }
        
        // For global site - change "Out of Stock" to "Sold Out"
        if (link.textContent.includes('Out of Stock')) {
          link.innerHTML = link.innerHTML.replace('Out of Stock', 'Sold Out');
        }
        
        // Change "Stokta" to "Satışta" for available products
        if (link.textContent.includes('Stokta') && !link.textContent.includes('Stokta yok')) {
          link.innerHTML = link.innerHTML.replace('Stokta', 'Satışta');
        }
        
        // For global site - change "In Stock" to "Available"
        if (link.textContent.includes('In Stock')) {
          link.innerHTML = link.innerHTML.replace('In Stock', 'Available');
        }
        
        // Also check for "In stock" (lowercase s)
        if (link.textContent.includes('In stock')) {
          link.innerHTML = link.innerHTML.replace('In stock', 'Available');
        }
        
        // Also check for "Out of stock" (lowercase s)
        if (link.textContent.includes('Out of stock')) {
          link.innerHTML = link.innerHTML.replace('Out of stock', 'Sold Out');
        }
      });
    }
  }

  // Combined function to run both updates
  function updateAllFilterTexts() {
    updateAvailabilityFilterText();
    updateActiveFiltersText();
  }

  // Run on page load
  document.addEventListener('DOMContentLoaded', updateAllFilterTexts);
  
  // Run after AJAX updates (for collection filtering)
  document.addEventListener('shopify:section:load', updateAllFilterTexts);
  
  // Run after any collection updates
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Check for filter changes or active filter changes
        if (mutation.target.querySelector('[name="filter.v.availability"]') || 
            mutation.target.querySelector('.active__filters__remove') ||
            mutation.target.classList.contains('collection__active__filters__wrapper')) {
          setTimeout(updateAllFilterTexts, 100); // Small delay to ensure content is loaded
        }
      }
    });
  });
  
  // Observe changes in the collection filters area
  const filtersContainer = document.querySelector('[data-collection-sidebar]');
  if (filtersContainer) {
    observer.observe(filtersContainer, { childList: true, subtree: true });
  }
  
  // Also observe the active filters wrapper specifically
  const activeFiltersWrapper = document.querySelector('.collection__active__filters__wrapper');
  if (activeFiltersWrapper) {
    observer.observe(activeFiltersWrapper, { childList: true, subtree: true });
  }

  // Override: Remove disabled attribute from Add to Cart buttons
  // Bu kod theme.js'in disabled eklemesini override eder
  
  // Butonların initial data'larını sakla
  const buttonInitialData = new WeakMap();
  
  function saveButtonInitialData() {
    const buttons = document.querySelectorAll('[data-add-to-cart]');
    buttons.forEach(button => {
      if (!buttonInitialData.has(button)) {
        buttonInitialData.set(button, {
          productId: button.getAttribute('data-product_id'),
          variantId: button.getAttribute('data-variant_id'),
          productPrice: button.getAttribute('data-product_price'),
          originalText: button.getAttribute('data-original-text')
        });
      }
    });
  }
  
  function updateAddToCartButton(button, variant) {
    // Varyant hiç çözülemiyorsa (zorunlu seçim yapılmamış ya da geçersiz kombinasyon)
    // buton kilitli kalmalı. Stokta-yok durumu BUNUN DIŞINDA: orada variant var,
    // sadece available=false — o akış (Gelince Haber Ver) aynen korunuyor.
    button.disabled = !variant;
    
    // İlk yüklemedeki data'ları al
    const initialData = buttonInitialData.get(button) || {};
    
    // Debug: variant bilgisini logla
    console.log('updateAddToCartButton called:', { variant, initialData });
    
    // Eğer variant yoksa veya available değilse onclick ve data attributelarını ekle
    if (!variant || !variant.available) {
      // onclick attribute'unu ekle
      button.setAttribute('onclick', 'openHollyNotificationStockOutModal(this); return false;');
      button.setAttribute('data-button_loader_color', '#000');
      button.setAttribute('data-button_loader_size', '20px');
      button.setAttribute('data-button_loader_width', '2px');
      button.setAttribute('data-button_type', 'InStock');
      button.style.width = '100%';
      button.style.display = 'flex';
      button.style.alignItems = 'center';
      button.style.justifyContent = 'center';
      
      // Product ID ve Variant ID - her ikisi de seçili variant'ın ID'si olmalı
      if (variant && variant.id) {
        button.setAttribute('data-product_id', variant.id);
        button.setAttribute('data-variant_id', variant.id);
      } else if (initialData.productId) {
        button.setAttribute('data-product_id', initialData.productId);
        button.setAttribute('data-variant_id', initialData.variantId || initialData.productId);
      }
      
      // Price'ı variant'tan al
      if (variant && variant.price) {
        // Shopify price cents cinsinden gelir, TL formatına çevir
        const formattedPrice = (variant.price / 100).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
        button.setAttribute('data-product_price', formattedPrice);
        console.log('Price set from variant:', formattedPrice);
      } else if (initialData.productPrice) {
        button.setAttribute('data-product_price', initialData.productPrice);
        console.log('Price set from initialData:', initialData.productPrice);
      }
      
      console.log('Button attributes after update:', {
        productId: button.getAttribute('data-product_id'),
        variantId: button.getAttribute('data-variant_id'),
        price: button.getAttribute('data-product_price')
      });
      
      // Original text attribute'unu ekle
      const buttonText = button.querySelector('[data-add-to-cart-text]')?.textContent?.trim();
      if (buttonText) {
        button.setAttribute('data-original-text', buttonText);
      } else if (initialData.originalText) {
        button.setAttribute('data-original-text', initialData.originalText);
      }
    } else {
      // Stok varsa onclick'i kaldır
      button.removeAttribute('onclick');
      button.removeAttribute('data-button_loader_color');
      button.removeAttribute('data-button_loader_size');
      button.removeAttribute('data-button_loader_width');
      button.removeAttribute('data-button_type');
      button.removeAttribute('data-original-text');
      button.removeAttribute('data-product_id');
      button.removeAttribute('data-variant_id');
      button.removeAttribute('data-product_price');
      // Style'ı varsayılana döndür
      button.style.width = '';
      button.style.display = '';
      button.style.alignItems = '';
      button.style.justifyContent = '';
    }
  }

  // Varyant çözülmüş mü? input[name="id"] boşsa zorunlu seçim yapılmamıştır.
  // Stokta-yok durumunda id DOLU olur; o akış (Gelince Haber Ver) etkilenmez.
  function hasResolvedVariant(button) {
    var form = button.closest('form') || document.querySelector('form[data-product-form]');
    var idInput = form
      ? form.querySelector('input[name="id"]')
      : document.querySelector('form[data-product-form] input[name="id"]');
    if (!idInput) return true; // ürün formu yoksa karışma
    return idInput.value !== '';
  }

  function removeAddToCartDisabled() {
    const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
    addToCartButtons.forEach(button => {
      if (hasResolvedVariant(button)) {
        button.disabled = false;
      }
    });
  }

  // Sayfa yüklendiğinde çalıştır
  document.addEventListener('DOMContentLoaded', function() {
    saveButtonInitialData();
    removeAddToCartDisabled();
    observeAddToCartButtons();
  });
  
  // Variant değiştiğinde çalıştır (theme.js bu eventi fırlatır)
function getProductScope(el) {
  return (
    el.closest('.product__section') ||
    el.closest('.product-single') ||
    el.closest('.shopify-section') ||
    el.parentElement ||
    document
  );
}

document.addEventListener('theme:variant:change', function(event) {
  var variant = event.detail.variant;
  var partial = event.detail.bendisPartial || null;
  var formContainer = event.target;
  var scope = getProductScope(formContainer);

  console.log('[VARIANT CHANGE]', { variant, formContainer, scope });

  const button = formContainer.querySelector('[data-add-to-cart]');

  setTimeout(function() {
    if (button) {
      updateAddToCartButton(button, variant);
    }

    updateDynamicComparePrice(scope, variant, partial);
  }, 50);
});

  // MutationObserver ile buton attribute değişikliklerini izle
  const buttonObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'disabled') {
        const button = mutation.target;
        if (button.hasAttribute('data-add-to-cart') && button.disabled && hasResolvedVariant(button)) {
          button.disabled = false;
        }
      }
    });
  });

  // Tüm Add to Cart butonlarını gözlemle
  function observeAddToCartButtons() {
    const buttons = document.querySelectorAll('[data-add-to-cart]');
    buttons.forEach(button => {
      buttonObserver.observe(button, { attributes: true });
    });
  }

  /* =========================================================================
     SEPET ADET LİMİTİ
     Bu ürün sepete yalnızca 1 adet eklenebilir. 2 veya daha fazla eklenmeye
     çalışılırsa otomatik olarak 1'e indirilir ve kullanıcı bilgilendirilir.
       Product ID : 10484016873781
       Variant ID : 52801241186613
     Uygulama: Tema her sepet değişikliğinde 'theme:cart:change' olayını
     tetikler; ayrıca sayfa yüklenince sepet kontrol edilir. Böylece tüm ekleme
     yolları kapsanır (ürün sayfası, hızlı ekle, sepet çekmecesi, sepet sayfası
     ve AJAX kapalıyken /cart sayfasına yönlendirme).
     ========================================================================= */
  (function cartQuantityLimit() {
    var LIMIT_VARIANT_ID = 52801241186613; // sınırlanan varyant
    var LIMIT_MAX = 1;                     // sepette izin verilen en fazla adet

    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    var isTR = lang.indexOf('tr') === 0 || lang === '';
    var LIMIT_MESSAGE = isTR
      ? 'Bu ürün sepete en fazla 1 adet eklenebilir.'
      : 'This product can only be added to the cart once.';

    var cartUrl = (window.theme && theme.routes && theme.routes.cart) || '/cart';
    var correcting = false; // eşzamanlı düzeltmeleri engellemek için kilit

    function showLimitNotice() {
      try {
        var id = 'cart-limit-toast';
        var old = document.getElementById(id);
        if (old && old.parentNode) { old.parentNode.removeChild(old); }
        var el = document.createElement('div');
        el.id = id;
        el.setAttribute('role', 'alert');
        el.textContent = LIMIT_MESSAGE;
        el.style.cssText = 'position:fixed;z-index:2147483647;left:50%;bottom:30px;' +
          'transform:translateX(-50%);background:#111;color:#fff;padding:12px 20px;' +
          'border-radius:6px;font-size:14px;line-height:1.3;max-width:90%;text-align:center;' +
          'box-shadow:0 6px 24px rgba(0,0,0,.25);opacity:0;transition:opacity .25s ease;';
        document.body.appendChild(el);
        requestAnimationFrame(function () { el.style.opacity = '1'; });
        setTimeout(function () {
          el.style.opacity = '0';
          setTimeout(function () { if (el.parentNode) { el.parentNode.removeChild(el); } }, 300);
        }, 3500);
      } catch (e) {
        console.warn('[cart-limit]', LIMIT_MESSAGE);
      }
    }

    // Limitli varyanta ait sepet satırını bul (cart.js satırında id === variant id)
    function findLimitedLine(cart) {
      if (!cart || !cart.items) { return null; }
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (Number(it.id) === LIMIT_VARIANT_ID || Number(it.variant_id) === LIMIT_VARIANT_ID) {
          return it;
        }
      }
      return null;
    }

    // Sepet sayfasındaki adet kutusunu da 1 ile sınırla (erken/kozmetik engel)
    function capQuantityInput(line) {
      if (!line) { return; }
      var input = document.querySelector('[data-update-cart="' + line.key + '"]');
      if (input) {
        input.setAttribute('max', String(LIMIT_MAX));
        if (Number(input.value) > LIMIT_MAX) { input.value = LIMIT_MAX; }
      }
    }

    function enforce(cart) {
      var line = findLimitedLine(cart);
      if (!line) { return; }
      capQuantityInput(line);
      if (line.quantity > LIMIT_MAX && !correcting) {
        correcting = true;
        fetch(cartUrl + '/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: line.key, quantity: LIMIT_MAX })
        })
          .then(function (r) { return r.json(); })
          .then(function (updatedCart) {
            showLimitNotice();
            // Tüm tema bileşenlerini güncelle (başlık sayacı, çekmece, sepet sayfası)
            document.dispatchEvent(new CustomEvent('theme:cart:change', {
              detail: { cart: updatedCart }, bubbles: true
            }));
            document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
          })
          .catch(function (err) { console.error('[cart-limit]', err); })
          .then(function () { correcting = false; });
      }
    }

    // Tema sepet olayları: her ekleme/güncelleme sonrası tetiklenir
    document.addEventListener('theme:cart:change', function (e) {
      if (e && e.detail && e.detail.cart) { enforce(e.detail.cart); }
    });
    document.addEventListener('theme:cart:init', function (e) {
      if (e && e.detail && e.detail.cart) { enforce(e.detail.cart); }
    });

    // İlk yüklemede sepeti kontrol et (özellikle sepet sayfası / AJAX kapalı akış)
    document.addEventListener('DOMContentLoaded', function () {
      fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(enforce)
        .catch(function () {});
    });
  })();


  document.addEventListener('click', function(e) {

  const btn = e.target.closest('#cart_clear_btn');

  if (!btn) return;

  e.preventDefault();

  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json'
    },
    credentials: 'same-origin'
  })
  .then(r => r.json())
  .then(cart => {

      document.dispatchEvent(new CustomEvent('theme:cart:change', {
          detail: {
              cart: cart
          },
          bubbles: true
      }));

      document.dispatchEvent(new CustomEvent('theme:cart:reload', {
          bubbles: true
      }));

  });

});


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
